export const ACCESSIBILITY_CHECK = 'accessibility_check';
export const CONFIRM_ACCESSIBILITY_SKIP = 'confirm_accessibility_skip';
export const CONFIRM_DELETE_ACCOUNT = 'confirm_delete_account';
export const DOWNLOAD_CCA_RESULTS = 'download_cca_results';
export const IAT_ASSESSMENT_TIMER_EXCEEDED = 'iat_assessment_timer_exceeded';
export const LANGUAGE_CHANGE_ERROR = 'language_change_error';
export const POLICY_CONSENT = 'policy_consent';
export const SKIP_IAT_NOTIFICATION = 'skip_iat_notification';
export const SKIP_IAT_OPTION = 'skip_iat_option';